import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${props => props.theme.colors.primaryBackground};

  .header {
    border-bottom: 1px #707070 solid;
    padding-bottom: 20px;

    h1 {
      font-size: 2.8rem;
      color: ${props => props.theme.colors.primaryText};
      margin: 0 0 40px 0;
    }

    .login-information {
      & > * {
        margin: 0 20px 30px 0;
      }

      .TextField-lgpd {
        width: 100%;
        max-width: 300px;

        > label {
          color: ${props => props.theme.colors.primaryText};
          font-size: 1.4rem;
        }

        .MuiInputBase-root {
          font-size: 1.4rem;

          input {
            color: ${props => props.theme.colors.primaryText};
            font-size: 1.4rem;
          }
          fieldset {
            border-color: #929292;
          }
        }
      }
    }
  }
`;
